/*function changeSelectTarimasMedida(inputId, selectId) {
      console.log("Cambiamos valor");
      // Obtener el valor ingresado en el input text
      var valorInput = document.getElementById(inputId).value;
      console.log("valorInput + " + valorInput)
      // Obtener el elemento select
      var select = document.getElementById(selectId);

      console.log("select + " + select)
      console.log("selectId + " + selectId);

      // Seleccionar el option correspondiente al valor ingresado
      for (var i = 0; i < select.options.length; i++) {
        if (select.options[i].value === valorInput) {
          select.options[i].selected = true;
          break;
        }
      }
      document.querySelector('product-variants').onVariantChange();
}*/

document.addEventListener("DOMContentLoaded", function() {
    // Obtener todos los elementos con la clase input_select_change
    var inputs = document.querySelectorAll(".input_select_change");

    // Iterar sobre cada elemento y agregar el evento blur
    inputs.forEach(function(input) {
        input.addEventListener("blur", function(event) {
            // Obtener el valor del input
            var valorInput = event.target.value.trim();
            
            // Verificar si el valor es un número y está dentro del rango permitido
            if (!isNaN(valorInput) && valorInput >= 50 && valorInput <= 130) {
                event.target.style.border = '';
                document.getElementById("add-to-cart").disabled = false;
                document.getElementById('error_input').style.display = 'none';
            } else {
                event.target.style.border = '1px solid red';
                document.getElementById('error_input').style.display = 'block';
                document.getElementById("add-to-cart").disabled = true;
                event.target.value = "";
            }
        });
    });
});



function changeSelectTarimasMedida(inputId, selectName) {
  console.log("Cambiamos valor");
  
  var valorInput = document.getElementById(inputId).value;
  console.log("valorInput + " + valorInput)

  // Obtener el select correspondiente al nombre proporcionado
  var select = document.querySelector('[id*=' + selectName + ']');

  console.log(select);
  // Verificar si se encontró el select
  if (select && select.tagName.toLowerCase() === 'select') {
    // Recorrer las opciones del select
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === valorInput) {
        select.options[i].selected = true;
        break;
      }
    }
    
    // Ejecutar la función 'onVariantChange()' en el elemento con la clase 'product-variants'
    document.querySelector('product-variants').onVariantChange();
  } else {
    console.error("No se encontró el select con el nombre proporcionado");
  }
}
